import { AddNewVendorUserInfo } from "@/mocks/data/vendorService/AddNewVendorUserForm";

const addNewVendorUserInformation = {
  getAddNewVendorDropdownData: async (): Promise<any> => {
    try {
      // const resp = await axios.get(`/packaging-service/api/v1/packaging/${vendorId}`)
      const resp = AddNewVendorUserInfo;
      return resp ?? null;
    } catch (error) {
      console.error("Error fetching vendor data:", error);
      throw error;
    }
  },
};

export default addNewVendorUserInformation;